const styles = theme => ({
  notFound: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexGrow: 1,
    marginTop: 100,
    marginBottom: 200,
  },
  display: {
    marginTop: "50px",
    lineHeight: "1em",
    marginBottom: theme.spacing(4),
    fontFamily: '"Oswald"',
    fontSize: "3.4rem",
  },
  text: {
    marginTop: 100,
    marginBottom: 200,
  },
  notFoundImg: {
    width: 360,
    alignSelf: "center",
    "@media (max-width: 900px)": {
      width: 260,
    },
  },
})

export default styles
